import FilterCheckboxChip from './FilterCheckboxChip';
import FilterSelect from '../Input/FilterSelect';
import { formatVolume } from 'utils/helpers';
import { handleMixpanelEvent } from '../FilterAccordion/FilterAccordionItem';
import styled from 'styled-components';
import { useFetchMostPopularTikTokAffinityRoots } from 'utils/hooks';
import { withMixpanelChange } from 'utils/app';

const Wrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.space_6}px;
`;

const TikTokAffinityFilterChipsUntracked = ({
    menus,
    filtersSansHealthStats,
    filters,
    setFilter,
    setFilters,
    filterNames,
    mixpanelMeta,
    getOnChange,
    appliedFilters,
    onChange,
    queryData,
    ...props
}) => {
    const { data, NoOptionsMessage, ...restQuery } =
        useFetchMostPopularTikTokAffinityRoots(queryData);
    const resetMenuFilters = () => {
        const cluster =
            filterNames.includes('parentName') ||
            filterNames.includes('tikTokParentName') ||
            filterNames.includes('healthStats')
                ? []
                : (filters.cluster || []).filter(({ value }) =>
                      value.includes('ris'),
                  );
        const tikTokParentName = (filters.tikTokParentName || []).filter(
            ({ value }) => data?.map(({ value }) => value).includes(value),
        );
        const nextFilters = {};

        if (cluster.length) {
            nextFilters.cluster = cluster;
        }

        if (tikTokParentName.length) {
            nextFilters.tikTokParentName = tikTokParentName;
        }

        setFilters(nextFilters);
    };
    return (
        <Wrapper {...props}>
            {menus && menus.length ? (
                <span id="data-table-filter-select">
                    <FilterSelect
                        filters={filtersSansHealthStats}
                        setFilter={setFilter}
                        resetFilters={resetMenuFilters}
                        mixpanelMeta={mixpanelMeta}
                        menus={menus}
                        getOnChange={getOnChange}
                        menuAlign="left"
                        queryData={queryData}
                        appliedFilterChipCount={data?.reduce(
                            (acc, { value }) =>
                                acc + (appliedFilters?.includes(value) ? 1 : 0),
                            0,
                        )}
                    />
                </span>
            ) : null}
            {data && data.length ? (
                data.map((option) => {
                    const { label, value, volume } = option;
                    const checked =
                        !!appliedFilters && appliedFilters.includes(value);

                    return (
                        <FilterCheckboxChip
                            checked={checked}
                            onChange={() =>
                                onChange({
                                    action: checked
                                        ? 'remove-value'
                                        : 'select-option',
                                    option,
                                })
                            }
                            preserveIconSpace={false}
                            key={label}
                        >
                            <span>
                                {label}{' '}
                                <span
                                    css={`
                                        font-weight: 500;
                                        margin-left: 0.5rem;
                                        color: ${({ theme }) => theme.gray_600};
                                        text-transform: uppercase;
                                    `}
                                >
                                    {formatVolume(volume)}
                                </span>
                            </span>
                        </FilterCheckboxChip>
                    );
                })
            ) : (
                <span>
                    <NoOptionsMessage {...restQuery} />
                </span>
            )}
        </Wrapper>
    );
};

const TikTokAffinityFilterChipsWithMixpanel = withMixpanelChange(
    TikTokAffinityFilterChipsUntracked,
    'TikTokAffinityFilterChips',
);

export const TikTokAffinityFilterChips = ({
    handleMixpanelEvent: handleMixpanelEventProp = handleMixpanelEvent,
    mixpanelContext = 'TikTokGroupFilterSelect',
    ...props
}) => {
    return (
        <TikTokAffinityFilterChipsWithMixpanel
            handleMixpanelEvent={handleMixpanelEventProp}
            mixpanelContext={mixpanelContext}
            {...props}
        />
    );
};

export default TikTokAffinityFilterChips;
